import React from 'react';
import Layout from '../../components/layout/Layout'
import { BenefitCardInfo } from './BenefitCardInfo';
import { useBenefitCard } from './hook/useBenefitCard';
import { BenefitCardAbout } from './BenefitCardAbout';
import { AdvantagesBenefitCard } from './AdvantagesBenefitCard';
import Faq from '../../components/faq/Faq';
import CreditCard from './CreditCard';

function BenefitCard() {
    const {
        faqs,
        limitBenefit,
        valueBenefit,
        setValueBenefit,
        getSubHeader,
        onGoToRegister
    } = useBenefitCard();

    return (
        <Layout subHeader={getSubHeader()}>
            <BenefitCardInfo
                limitBenefit={limitBenefit}
                setValueBenefit={setValueBenefit}
                valueBenefit={valueBenefit}
                onGoToRegister={onGoToRegister}
            />
            <BenefitCardAbout onGoToRegister={onGoToRegister} />
            <CreditCard onGoToRegister={onGoToRegister}/>
            <AdvantagesBenefitCard onGoToRegister={onGoToRegister}/>
            <Faq
                faqs={faqs}
                title={'Tire suas dúvidas sobre os Cartões de Crédito Consignado Bmg'}
            />
        </Layout>
    );
}

export default BenefitCard;